import React from "react";
import useStats from "./utils";
import { BeatLoader } from "react-spinners";

import DataStats from "./pages/statCharts";
const Stats = ({ url }) => {
  const { stats, loading, error } = useStats(url);
  if (loading) return <BeatLoader loading color="red" />;
  if (error) return <p>Error...</p>;
  return (
    <React.Fragment>
      <DataStats data={stats} />
    </React.Fragment>
  );
};

export default Stats;
